<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" />
        <!-- Card body -->
        <form role="form" @submit.prevent="create">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error')}} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <div class="row">
              <input-text v-model="en_name" :options="{ id: 'en_name', label: 'en_name', error: fieldErrors.name }"/>
              <input-text v-model="ar_name" :options="{ id: 'ar_name', label: 'ar_name', error: fieldErrors.nameAr }"/>
            </div>
            <div class="row">
              <div class="col-12">
                <maps-general v-model="points" :points="oldPoints" :mode="map_mode"/>
              </div>
            </div>
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <router-link :to="{ name: `${citiesRoutePrefix}.index`,params:{id} }"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
                <button type="submit" class="btn btn-primary btn-sm" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                  <i class="fa fa-save"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import { CITIES_CREATE as CRUD_ACTION_CREATE } from 'actions/cities';
  const CRUD_CODE="countries";
  const CITIES_CODE="cities";
  export default {
    name: "CountryCityCreate",
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        citiesRoutePrefix: `${CRUD_CODE}.${CITIES_CODE}`,
        citiesTransPrefix: `${CITIES_CODE}`,
        id:this.$router.currentRoute.params.id,
        en_name: '',
        ar_name: '',
        points:[],
        oldPoints:[],
        map_mode:'create',
        serverError: '',
        fieldErrors: {},
        loading: false,
      }
    },
    methods: {
      prepareGeomRequestData(){
        let geom={};
        if(this.points.length ){
          geom.geom= {
            type: "MultiPolygon",
            coordinates:[[this.points]],
          };
        }

        return geom;
      },
      prepareRequestData(){
        return {
          name: this.sanitizeField('en_name'),
          nameAr: this.sanitizeField('ar_name'),
          countryId: this.sanitizeField('id'),
          ...this.prepareGeomRequestData()
        }
      },
      create() {
        this.loading = true
        this.$store.dispatch(CRUD_ACTION_CREATE, {
          ...this.prepareRequestData(),

        })
        .then(() => {
          swal({
            icon: 'success',
            text: this.$i18n.t("messages.create_successfully"),
            buttons:false,
            timer: 5000
          });
          this.$router.push({ name: `${this.citiesRoutePrefix}.index`, params:{id:this.id} })
        })
        .catch(error => {
          this.loading = false
          this.fieldErrors={};
          this.serverError='';

          if(error.response){
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        })
      }
    }
  };
</script>
